import api from "./api";
import currentUserId from "../reduxSaga/sagas/requests/currentUserId";
import UtilsUrl from "../utils/UtilsUrl";

// const BASE_BK_URL = "http://localhost:8082/gateway/finance/Banque"
// const BASE_BK_URL = "http://192.168.1.112:8082/gateway/finance/Banque"

class CompteCaisseService {
  getAllBanqueNames() {
    return api.get(UtilsUrl.bankURL() + "/getAllBanque");
  }
  getAllAgenceNames(banqueName) {
    return api.get(UtilsUrl.bankURL() + "/getAllAgencesBanque/" + banqueName);
  }

  //new
  getAllAgenceAndBank(idUser) {
    return api.get("/retail/banque/getAllAgenceAndBank/" + idUser);
  }

  addBankCaisse(payFactureOrAvance) {
    let currentUser = currentUserId();
    return api.post(`/retail/banque/addBankAccount`, payFactureOrAvance);
  }

  getAllBankAccounts() {
    let currentUser = currentUserId();
    return api.get(`/retail/banque/getAllBankAccounts/${currentUser}`);
  }
}

export default new CompteCaisseService();
